import ssoClient, { ROUTES } from '@airasia-common/libraries/http/ssoClient';

export const getMemberId = (email, firstName, lastName) => () => {
  const params = { username: email, firstName, lastName };

  return ssoClient.get(ROUTES.NAVITAIRE, { params });
};
